import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { etiquetaGrupoRolls, formatCombinacionSummary } from '../constants/comboCombinaciones';
import { formatWasabiGingerSummary } from '../constants/wasabiGinger';
import { refAmount } from '../utils/money';
import './Cart.css';
import rollDinamitaImage from '../assets/Tipos de Rolls/ROLL Camaron - Dinamita.png';

const Cart = () => {
  const navigate = useNavigate();
  const { cartItems, isCartOpen, closeCart, updateQuantity, removeFromCart, getTotalPrice } = useCart();


  const handleQuantityChange = (item, delta) => {
    const newQuantity = item.quantity + delta;
    updateQuantity(item.id, item.type, newQuantity);
  };

  const handleRemoveItem = (item) => {
    removeFromCart(item.id, item.type);
  };

  if (!isCartOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={closeCart}></div>
      <div className={`cart-sidebar ${isCartOpen ? 'open' : ''}`}>
        <div className="cart-header">
          <h2 className="cart-title">Carrito ({cartItems.length})</h2>
          <button className="cart-close-btn" onClick={closeCart}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="cart-content">
          {cartItems.length === 0 && (
            <div className="cart-empty">
              <p>Tu carrito está vacío</p>
            </div>
          )}
          {cartItems.length > 0 && (
            <>
              <div className="cart-items">
                {cartItems.map((item) => (
                  <div key={`${item.id}-${item.type}`} className="cart-item">
                    <div className="cart-item-image">
                      <img 
                        src={item.image || rollDinamitaImage} 
                        alt={item.name}
                        className="cart-item-img"
                      />
                    </div>
                    <div className="cart-item-info">
                      <h3 className="cart-item-name">{item.name}</h3>
                      <span className="cart-item-price">Ref {refAmount(item.price)}</span>
                      {item.type === 'extra' && item.accompaniments?.length > 0 && (
                        <div className="cart-item-combinaciones">
                          <span className="cart-combinacion-line">
                            {formatWasabiGingerSummary(item.accompaniments)}
                          </span>
                        </div>
                      )}
                      {item.type === 'combo' &&
                        ((item.combinaciones && item.combinaciones.length > 0) ||
                          (item.includedSauces && item.includedSauces.length > 0) ||
                          item.includedDrink) && (
                        <div className="cart-item-combinaciones">
                          {item.rollsConSesamo !== undefined && (
                            <span className="cart-combinacion-line cart-combinacion-sesamo">
                              Sésamo: {item.rollsConSesamo ? 'Sí' : 'No'}
                            </span>
                          )}
                          {item.rollsConQuesoCrema !== undefined && (
                            <span className="cart-combinacion-line cart-combinacion-queso">
                              Queso crema: {item.rollsConQuesoCrema ? 'Sí' : 'No'}
                            </span>
                          )}
                          {item.rollsConCebollin !== undefined && (
                            <span className="cart-combinacion-line cart-combinacion-queso">
                              Cebollín: {item.rollsConCebollin ? 'Sí' : 'No'}
                            </span>
                          )}
                          {item.rollsConQuesoCrema === undefined &&
                            item.rollsConCebollin === undefined &&
                            item.rollsConQuesoCremaCebollin !== undefined && (
                            <span className="cart-combinacion-line cart-combinacion-queso">
                              Queso crema y cebollín:{' '}
                              {item.rollsConQuesoCremaCebollin ? 'Sí' : 'No'}
                            </span>
                          )}
                          {item.combinaciones?.map((combi, i) => (
                            <span key={`c-${i}`} className="cart-combinacion-line">
                              {etiquetaGrupoRolls(i)}: {formatCombinacionSummary(combi)}
                            </span>
                          ))}
                          {item.includedSauces?.map((sauce, i) => (
                            <span key={`s-${sauce.id ?? i}`} className="cart-combinacion-line">
                              Salsa: {sauce.product_name} ×{sauce.quantity}
                            </span>
                          ))}
                          {item.includedDrink && (
                            <span className="cart-combinacion-line">
                              Bebida: {item.includedDrink.product_name}
                            </span>
                          )}
                        </div>
                      )}
                      <div className="cart-item-quantity-section">
                        <span className="cart-item-quantity-label">Cantidad: {item.quantity} Uni</span>
                        <div className="cart-item-quantity-controls">
                          <div className="cart-quantity-selector">
                            <button 
                              className="cart-quantity-btn"
                              onClick={() => handleQuantityChange(item, -1)}
                            >
                              -
                            </button>
                            <span className="cart-quantity-value">{item.quantity}</span>
                            <button 
                              className="cart-quantity-btn"
                              onClick={() => handleQuantityChange(item, 1)}
                            >
                              +
                            </button>
                          </div>
                          <button 
                            className="cart-remove-btn"
                            onClick={() => handleRemoveItem(item)}
                          >
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {cartItems.length > 0 && (
            <>
              <div className="cart-total">
                <div className="cart-total-amount">
                  <span className="cart-total-label">Total</span>
                  <span className="cart-total-value">Ref {getTotalPrice()}</span>
                </div>
                <p className="cart-total-note">
                  Los impuestos y gastos de envío se calculan en la pantalla de pago
                </p>
              </div>

              <button 
                className="cart-checkout-btn"
                onClick={() => {
                  closeCart();
                  navigate('/checkout?step=1');
                }}
              >
                IR A PAGAR
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Cart;

